module.exports = __webpack_public_path__ + "img/bg-recommend.3f833d3a.png";